import { merge } from "lodash";
import { generateEndpoints, prefix } from "../helpers";

/**
 * This is the reource identifier
 * Everything will be under users.get, users.getAll, users.create, users.createAndSendEmail etc...
 */
const namespace = "skill";

const nameSpace = merge({}, generateEndpoints(namespace), {
  get: {
    getList: (roleId) => [!!roleId ? `${prefix}/profile/${namespace}?roleId=${roleId}` : `${prefix}/profile/${namespace}`],
    getCategoryList: () => [`${prefix}/profile/${namespace}/category`],
    getSkillsFromLoggedUser: () => [`${prefix}/profile/profile/${namespace}`],
  },

  post: {
    // create: (data) => [`profile/${namespace}`, data]
  },
  put: {
    // update: (id, data) =>  [`profile/${namespace}/${id}`, data],
  },
});

export default nameSpace;
